import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  ApiEnvelope,
  SuperBillDetails,
} from "@/pages/app/provider/billings/billing-types";
import { SuperBillControllerApi } from "../../services";
import { getConfigObject } from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */
interface GetSuperBillParams {
  superBillUuid: string;
  xTENANTID?: string;
}

export function useGetSuperBill({
  superBillUuid,
  xTENANTID,
}: GetSuperBillParams): UseQueryResult<
  ApiEnvelope<SuperBillDetails> | undefined,
  AxiosError
> {
  return useQuery({
    queryKey: ["Get-Super-Bill", superBillUuid, xTENANTID],
    refetchOnWindowFocus: false,
    enabled: !!superBillUuid,
    queryFn: async () =>
      new SuperBillControllerApi(getConfigObject())
        .getSuperBillById(superBillUuid, xTENANTID)
        .then((it) => it?.data as ApiEnvelope<SuperBillDetails>),
  });
}
